"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AspectRatioLimitter = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var resize_observer_hooks_1 = require("../hooks/resize-observer-hooks");
var Root = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
exports.AspectRatioLimitter = (0, react_1.memo)(function (_a) {
    var children = _a.children, maxWidthPerHeight = _a.maxWidthPerHeight, minWidthPerHeight = _a.minWidthPerHeight;
    var _b = tslib_1.__read((0, resize_observer_hooks_1.useResizeObserver)(), 2), wrapperSize = _b[0], ref = _b[1];
    var padding = (0, react_1.useMemo)(function () {
        var width = wrapperSize.width, height = wrapperSize.height;
        if (minWidthPerHeight !== undefined &&
            width < minWidthPerHeight * height) {
            // 制約条件より縦長な場合 => 上下に余白を作る
            var pad = (height - width / minWidthPerHeight) / 2;
            return {
                top: pad,
                left: 0,
                right: 0,
                bottom: pad
            };
        }
        if (maxWidthPerHeight !== undefined &&
            width / height > maxWidthPerHeight) {
            // 制約条件より横長な場合 => 左右に余白を作る
            var pad = (width - height * maxWidthPerHeight) / 2;
            return {
                top: 0,
                left: pad,
                right: pad,
                bottom: 0
            };
        }
        return {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        };
    }, [maxWidthPerHeight, minWidthPerHeight, wrapperSize]);
    var wrapperStyle = (0, react_1.useMemo)(function () { return ({
        paddingTop: "".concat(padding.top, "px"),
        paddingLeft: "".concat(padding.left, "px"),
        paddingRight: "".concat(padding.right, "px"),
        paddingBottom: "".concat(padding.bottom, "px")
    }); }, [padding]);
    return (react_1.default.createElement(Root, { ref: ref, style: wrapperStyle }, children));
});
exports.AspectRatioLimitter.displayName = 'AspectRatioLimitter';
var templateObject_1;
